// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"6ae3d5bc","279":"073373df","369":"59fb87e8","394":"4a685df7","399":"8c6b567d","473":"f3d0d0e5","569":"5e76d11d","639":"d7050652","648":"ddcaa9b8","707":"4d324e3e","716":"3d891037","801":"e4d6b7b2","956":"88f8bd89"}[chunkId] + ".chunk.js";
};